
  import {Component, Vue} from "vue-property-decorator";
  import {IHome} from "@/modules/Home/interfaces/home.interface";
  import {httpResource} from "@/resources/http.resource";
  import {antiTheftCars} from "@/modules/CarList/mixins/antitheft.class";
  import {bus} from "@/plugins/bus";
  import HomeLogo from "@/modules/Home/components/main/HomeLogo.vue";
  import HomeAdditionalControls from "@/modules/Home/components/main/HomeAdditionalControls.vue";
  import HomeCars from "@/modules/Home/components/main/HomeCars.vue";
  import HomeControls from "@/modules/Home/components/main/HomeControls.vue";
  import HomePrivateAccess from "@/modules/Home/components/main/HomePrivateAccess.vue";

  @Component({
    components: {
      HomePrivateAccess,
      HomeControls,
      HomeCars,
      HomeAdditionalControls,
      HomeLogo,
    },
  })
  export default class UserIntro extends Vue {
    $refs: any;
    loading = true;
    homeData: IHome.IData = null;

    async created() {
      await this.getHomeInfo();
      this.loading = false;
    }

    mounted() {
      bus.$on(IHome.EmitterEvents.UpdateCarInfo, this.updateCarInfo);
    }

    async getHomeInfo() {
      let asyncAction = async () => {
        let action = IHome.Action;
        let params = { command: IHome.Command.Get, };
        const {data: { result: homeData } } = await httpResource.httpAction({ action, params });
        this.homeData = {
          ...homeData,
          extModeFlag: Boolean(homeData.extModeFlag),
          requestAccessFlag: Boolean(homeData.requestAccessFlag),
        };
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async updateCarInfo() {
      await this.getHomeInfo();
      await antiTheftCars.getAntiTheftInfo(this);
      this.$refs.homeCars.refreshCarInfo();
    }

    destroyed() {
      bus.$off(IHome.EmitterEvents.UpdateCarInfo);
    }
  }
